var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrandMarkBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 439.32 521.7"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M309.29 173.91 439.32 0h-235.5L73.72 173.91h93.31L36.95 347.79h93.13L0 521.7h235.57L365.6 347.79h-93.1l130.05-173.88h-93.27z"
})));
export default SvgBrandMarkBlack;